// extracted by mini-css-extract-plugin
module.exports = {"control":"ProductSliderControl_control__xQi5O","leftControl":"ProductSliderControl_leftControl__S84sO","rightControl":"ProductSliderControl_rightControl__NaDLK"};